import {CodeDtService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        codeList: []
    },

    mutations: {
        saveSelectedList(current, form) {
            current.codeList = {...form};
        }
    },

    actions: {
        async getCodeAction({commit}, id) {
            return await bindLoading(commit,
                async () => {
                    const rst = await CodeDtService.get(id);
                    commit('saveSelectedList', rst)
                    return rst;
                }, 'codeDt')
        },
        
        async getCodeNo({ commit }, id) {
            return await bindLoading(commit,
                async () => {
                    const rst = await CodeDtService.getNo(id);
                    commit('saveSelectedList', rst)
                    return rst;
                }, 'codeDt')
        },
        
        async getCodeAll({commit}) {
            return await bindLoading(commit,
                async () => {
                    const rst = await CodeDtService.getAll();
                    if (rst.success) {
                        commit('saveSelectedList', rst.instance)
                    }
                    return rst;
                }, 'codeDt')
        },
        
        async copyCodeSet({commit}, data) {
            return await bindLoading(commit,
                async () => {
                    const res = await CodeDtService.copyCodeSet(data);
                    return res;
                }, 'codeDt');
        },
        
        async getAllSet({commit}) {
            return await bindLoading(commit,
                async () => {
                    const rst = await CodeDtService.getAllSet();
                    if (rst.success) {
                        commit('saveSelectedList', rst.instance)
                    }
                    return rst;
                }, 'codeDt')
        },
        
        async update({commit}, data) {
            return await bindLoading(commit,
                async () => {
                    const res = await CodeDtService.update(data);
                    return res;
                }, 'codeDt');
        },
    }

}